"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreLocalStorage = void 0;
const localforage_1 = __importDefault(require("localforage"));
const lodash_1 = require("lodash");
const localStorage = localforage_1.default.createInstance({
    name: "app-local",
});
class StoreLocalStorage {
    storesWithValues = [];
    namespace;
    constructor(namespace = "store-local-storage") {
        this.namespace = namespace;
    }
    addStore({ key, store, values = [], deepValues = [] }) {
        this.storesWithValues.push({
            key,
            store,
            values,
            deepValues,
        });
    }
    async initiateLocalStorageValues() {
        for (const SV of this.storesWithValues) {
            const localStorageValue = await localStorage.getItem(`${this.namespace}_${SV.key}`);
            const foundLocal = JSON.parse(localStorageValue != null ? localStorageValue : "{}");
            let foundDeepValues = {};
            if (SV.deepValues.length > 0) {
                const localStorageDeepValue = await localStorage.getItem(`${this.namespace}_${SV.key}_deep`);
                foundDeepValues = JSON.parse(localStorageDeepValue != null ? localStorageDeepValue : "{}");
            }
            SV.store.update((s) => {
                for (const [key, value] of Object.entries(foundLocal)) {
                    s[key] = value;
                }
                for (const deepValPath of SV.deepValues) {
                    if (foundDeepValues.hasOwnProperty(deepValPath)) {
                        (0, lodash_1.set)(s, deepValPath, foundDeepValues[deepValPath]);
                    }
                }
            });
            SV.store.subscribe((s) => (0, lodash_1.pick)(s, SV.values), (keepLocal) => {
                localStorage.setItem(`${this.namespace}_${SV.key}`, JSON.stringify(keepLocal));
            });
            if (SV.deepValues.length > 0) {
                SV.store.subscribe((s) => {
                    const resp = {};
                    for (const deepValPath of SV.deepValues) {
                        resp[deepValPath] = (0, lodash_1.get)(s, deepValPath);
                    }
                    return resp;
                }, (keepLocal) => {
                    localStorage.setItem(`${this.namespace}_${SV.key}_deep`, JSON.stringify(keepLocal));
                });
            }
        }
    }
}
exports.StoreLocalStorage = StoreLocalStorage;
